import {
  createValidation,
  validatorRequired,
} from '../../utils/formValidators';

import { invoiceFields } from '../../constants/invoice';

export default createValidation([
  {
    name: invoiceFields.NUMBER,
    validators: (field) => validatorRequired()(field),
  },
  {
    name: invoiceFields.DATE,
    validators: (field) => validatorRequired()(field),
  },
]);
